export class User {
    userName: string;
    profileName: string;
    role: string;
    avatar: string;
}
